var render = function render(){var _vm=this,_c=_vm._self._c;return _c('body',[_c('div',{staticClass:"auth"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"content"},[_c('router-view')],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }